module.exports = __webpack_public_path__ + "8900df80ce9cb77facce367e8fd95153.svg";